var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auth-callback-container" }, [
    _c("div", { staticClass: "uk-text-center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("h3", { staticClass: "auth-message" }, [_vm._v(_vm._s(_vm.message))]),
      _vm._v(" "),
      _c("div", { staticClass: "auth-logo" }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner-container" }, [
      _c("div", { attrs: { "uk-spinner": "ratio: 3" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }